module.exports = __webpack_public_path__ + "static/media/wagyu_step_1.dc718c58.png";